import {
    DigestFilter,
    DigestFilterOperator,
    DigestLogicalOperator,
    DigestQueryFilter,
} from "../../../../../Common/CandyApiClient/DigestApiClient/Types/DigestQueryFilter";
import { Predicate } from "../../../../../Common/Funcs";

import { PicklistDataItem, PicklistQueryResponse } from "./PicklistTypes";

export function buildFilterPredicate(filter: DigestFilter | undefined): Predicate<PicklistDataItem> {
    if (filter == undefined) {
        return () => true;
    }
    switch (filter?.operator) {
        case DigestFilterOperator.Equal: {
            const filterValue: string = filter.value.toLowerCase();
            return item => (item[filter.column]?.toString().toLowerCase() ?? "") === filterValue;
        }
        case DigestFilterOperator.Prefix: {
            const filterValue: string = filter.value.toLowerCase();
            return item => (item[filter.column]?.toString().toLowerCase() ?? "")?.startsWith(filterValue) ?? false;
        }
        case DigestFilterOperator.Substring: {
            const filterValue: string = filter.value.toLowerCase();
            return item => (item[filter.column]?.toString().toLowerCase() ?? "")?.includes(filterValue) ?? false;
        }
        case DigestFilterOperator.ContainsInList: {
            const filterValue: string = filter.value.toLowerCase();
            return item =>
                (item[filter.column]?.toString().toLowerCase() ?? "")?.split(",").includes(filterValue) ?? false;
        }
        case DigestLogicalOperator.Or: {
            if (filter.operands.length === 0) {
                return () => true;
            }
            const operandPredicates = filter.operands.map(x => buildFilterPredicate(x));
            return item => operandPredicates.some(x => x(item));
        }
        case DigestLogicalOperator.And: {
            const operandPredicates = filter.operands.map(x => buildFilterPredicate(x));
            return item => operandPredicates.every(x => x(item));
        }
        default:
            return () => true;
    }
}
export function gPathFilter(items: Iterable<PicklistDataItem>, filterQuery?: DigestQueryFilter): PicklistQueryResponse {
    let firstItem: PicklistDataItem | undefined;
    let suitableCount: number = 0;
    const filterPredicate = buildFilterPredicate(filterQuery?.filter);
    const result = Iterator.from(items)
        .map(item => {
            firstItem = firstItem ?? item;
            return item;
        })
        .filter(filterPredicate)
        .map(item => {
            suitableCount++;
            return item;
        })
        .toArray();
    const slicedResult = Iterator.from(result)
        .drop(filterQuery?.skip ?? 0)
        .take(filterQuery?.take ?? Infinity)
        .toArray();
    return {
        items: slicedResult,
        suitableCount: suitableCount,
        columnMetas: Object.keys(firstItem ?? {}).map(x => ({ name: x, withMarkdown: false })),
    };
}
